export function blendRGBAOverRGB(baseRGB, overlayRGBA) {
  const { r: Rb, g: Gb, b: Bb } = baseRGB
  const { r: Ro, g: Go, b: Bo, a } = overlayRGBA

  const R = Math.round(Rb * (1 - a) + Ro * a)
  const G = Math.round(Gb * (1 - a) + Go * a)
  const B = Math.round(Bb * (1 - a) + Bo * a)

  return { r: R, g: G, b: B }
}

export function hexToRgb(hex) {
  hex = hex.replace('#', '')
  return {
    r: parseInt(hex.substring(0, 2), 16),
    g: parseInt(hex.substring(2, 4), 16),
    b: parseInt(hex.substring(4, 6), 16),
  }
}

export function rgbToHex({ r, g, b }) {
  return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')
}

export function blendedGradient(baseColor) {
  const base = hexToRgb(baseColor)

  const stop1 = blendRGBAOverRGB(base, { r: 0, g: 0, b: 0, a: 0.3 })
  const stop2 = blendRGBAOverRGB(base, { r: 0, g: 0, b: 0, a: 0.03 })

  const hex1 = rgbToHex(stop1)
  const hex2 = rgbToHex(stop2)

  return `linear-gradient(270deg, ${hex1} 0%, ${hex2} 100%)`
}

export function addOpacity(hex, opacity) {
  const alpha = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0')

  return hex + alpha
}
